export class TasksTask
{
	constructor(options = {name: "MainUiGrid"}) {
		this.name = options.name;

        BX.ready(this.init.bind(this))
	}

    init() {
        this.hideAnketologDangerMapTaskHistoryNotUsedStatues();
    }

    hideAnketologDangerMapTaskHistoryNotUsedStatues() {
        if (BX.message("ANKETOLOG_DANGERMAP_TASK_HISTORY_HIDE_STATUSES")) {
            let arStatuses = Array.from(document.querySelectorAll("#task-log-block .task-log-where"));
            arStatuses = arStatuses.forEach(domItem => {
                let sStatusName = domItem.innerHTML.trim();
                if (sStatusName == "Статус") {
                    let sWhatHappend = domItem.parentNode.parentNode.querySelector(".task-log-what").textContent;
                    if (sWhatHappend != "Ждет выполнения→Ждет контроля") {
                        if (domItem.parentNode.parentNode.previousElementSibling) {
                            domItem.parentNode.parentNode.previousElementSibling.remove();
                        }
                        domItem.parentNode.parentNode.remove();
                    }
                }
            });
        }
    }
}
